import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserGroupState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UserGroupState = {
  data: [],
  isLoading: false,
  error: null,
};

const userGroupSlice = createSlice({
  name: 'userGroups',
  initialState,
  reducers: {
    setUserGroups: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUserGroupLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUserGroupError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setUserGroups, setUserGroupLoading, setUserGroupError } = userGroupSlice.actions;

export default userGroupSlice.reducer;
